import Shimmer from '@/components/business/Shimmer';

/**
 * App-level loading placeholder used by the router / auth-context while
 * booting. Historically this rendered a centered spinner; the "instead of
 * loading, show shimmer" ask means it now renders a full-page shimmer that
 * matches the shape of the destination page (title + list).
 *
 * ``label`` is kept for accessibility (announced to screen readers via
 * ``sr-only``) but no longer painted in the primary layout.
 */
export default function LoadingScreen({ label = 'Loading…' }) {
  return (
    <div className="max-w-3xl mx-auto p-4 sm:p-6" data-testid="loading-screen">
      <Shimmer.Page rows={4} />
      <span className="sr-only">{label}</span>
    </div>
  );
}
